import React from "react";
import { LeftSidebar, Topbar } from "./OrderTemplateComponenent";
import { Header, TopBar } from "../../components/Header";
import { Footer } from "../../components/Footer";


export function OrderTemplate({page, children}) 
{
 
  return (

    <div className="container-fluid bg-light-gray min-vh-100">
      
      {/* ______________ SECTION HEADER ORDER'S TEMPLATE ________________ */}

      <div className='row mb-5'> 
        <TopBar /> 
        <Header page={6} />
      </div>
  
      {/* ______________ SECTION 1 ORDER'S TEMPLATE ________________ */}
      
      <div className="row d-flex justify-content-center mb-5 pb-5 pt-4">
          <div className="col-lg-11">
            <div className="row d-flex justify-content-between flex-lg-row">

              {/* Sidebar: on lg it’s right, but on md it goes first */}                
              <LeftSidebar />

              {/* Main content: on lg it’s left, on md it goes after */}
              <div className="col-lg-7 rounded-3"> 
                <div className="row sticky-top">
                  <div className="col-lg-12">   
                    <div className="border bg-white text-secondary rounded-top-3">
                      <div className="d-flex align-items-center border-bottom px-4 py-3 fs-5">
                        <i className="bi bi-receipt me-2"></i> Gestion des commandes  
                      </div>  
                      <div className="d-flex flex-column">
                        <Topbar active={page} /> 
                      </div> 
                    </div>
                  </div>
                </div>
                {/* ______________ FRAME TEMPLATE ________________ */}
                <div className="row">
                  { children }
                </div>
              </div>

            </div>
          </div>
      </div>
      
      {/* ______________ SECTION HEADER ORDER'S TEMPLATE ________________ */}

      <div className='row'> 
        <Footer />
      </div>
      
    </div>
  );
}
